(function () {
    "use strict";
    handleChangeTitlePosition(window.innerWidth);
    handleCompareAtPriceInfoHandlers()
})();

window.onresize = () => {
    handleChangeTitlePosition(window.innerWidth);
};

function handleChangeTitlePosition(windowWidth) {
    let productTitle;
    let container;
    if (windowWidth <= 768) {
        productTitle = document.querySelector(
            ".product-info .product-info__title",
        );
        container = document.querySelector(
            ".product-gallery-and-more .mobile-title-wrapper",
        );
        if (!productTitle) return;
        productTitle.classList.toggle("product-info__block");
        productTitle.classList.toggle("product-info__block--sm");
    } else {
        productTitle = document.querySelector(
            ".product-gallery-and-more .mobile-title-wrapper .product-info__title",
        );
        container = document.querySelector("[id*=ProductInformation-]");
        if (!productTitle) return;
        productTitle.classList.toggle("product-info__block");
        productTitle.classList.toggle("product-info__block--sm");
    }
    if (container) container.insertBefore(productTitle, container.firstChild);
}

function handleCompareAtPriceInfoHandlers() {
    document.addEventListener("click", (event) => {
        const details = document.querySelector(
            ".compare-at-price-info-details[open]",
        );
        if (details && !details.contains(event.target)) {
            details.removeAttribute("open");
        }
    });
    const compareAtPriceInfoDetails = document.querySelector(
        ".compare-at-price-info-details",
    );
    const summary = compareAtPriceInfoDetails.querySelector("summary");
    if (compareAtPriceInfoDetails && summary) {
        summary.addEventListener("mouseenter", (event) => {
            compareAtPriceInfoDetails.setAttribute("open", "");
        });

        compareAtPriceInfoDetails.addEventListener("mouseleave", (event) => {
            compareAtPriceInfoDetails.removeAttribute("open");
        });

        compareAtPriceInfoDetails.addEventListener("focusout", (event) => {
            compareAtPriceInfoDetails.removeAttribute("open");
        });
    }
}
